module.exports = __webpack_public_path__ + "img/lineoa.b1292255.svg";